import koalition from '../../../api/koalition'
import useFormBuilder from '../../../hooks/FormBuilderHook'
import Input from '../../forms/Input/Input'
import Validators from '../../../forms/Validators'
import Select from '../../forms/Select/Select'
import useConfirmation from '../../../hooks/ConfimationHook'
import { useModal } from '../../../contexts/Modal'
import { useEffect, useRef } from 'react'
import { useToaster } from '../../../contexts/Toaster'
import { kvkTypes } from '../../../utilities/constants'
import { capitalize } from '../../../utilities/helpers'

const WriteKvk = ({}) => {
    const modal = useModal()
    const toaster = useToaster()
    const formName = 'writeKvkPerformance'
    const { kvk, character } = modal.$state.data
    const kvkPerformance = kvk.performances[character._id]

    const writeKvkPerformanceRef = useRef()
    writeKvkPerformanceRef.current = () => {
        const formValues = form.$state.value

        koalition.put(`kvks/${kvk._id}/performance`, { ...formValues, characterId: character._id }).then((response) => {
            modal.close()
            toaster.success('Kvk performance saved successfully')
        }).catch((error) => {
            toaster.error(error)
            console.error(error)
        })
    }

    const form = useFormBuilder({ formName, onSubmit: () => writeKvkPerformanceRef.current(), controls: {
        position: { validators: [Validators.required, Validators.integer, Validators.min(0)], value: kvkPerformance?.position },
        score: { validators: [Validators.integer, Validators.min(0)], value: kvkPerformance?.score },
    } })

    useEffect(() => {
        modal.configure({ formName, submitLabel: 'Save' })
    }, [])

    return (
        <div className="row justify-content-center">
            <div className="col-sm-4 mb-3">
                <Input type="number" control={form.$state.controls.position} label="Position" />
            </div>

            <div className="col-sm-8 mb-3">
                <Input type="number" control={form.$state.controls.score} label="Score" />
            </div>
        </div>
    )
}

export default WriteKvk